<template>
    <div class="my-bookings-catalog default-content">
        <h1 class="my-bookings-catalog__title">{{ locales && locales.pages && locales.pages.my_bookings }}</h1>
        <div class='theme-alert theme-alert--info mb-3' v-if="page.info_block">
            <div class='theme-alert__icon'><i class='icon-notice'></i></div>
            <div class='theme-alert__text' v-html="page.info_block"></div>
        </div>
        <div class="container-shadow">
            <div class="my-bookings-catalog-filters">
                <div class="my-bookings-catalog-filters__upper-filters">
                    <div class="flex gap-2">
                        <!-- v-model="searchTerm" -->
                        <theme-input class="md:w-full lg:w-[246px] xl:w-[350px]" name="filter_property_id"
                            :placeholder="searchtermPlaceholder" @input="debouncedChangeSearchTerm" :isExtraInfo='true'
                            :value="searchTerm">
                            <template slot='extra-info'>
                                <i class='icon-search' />
                            </template>
                        </theme-input>

                        <a class="my-bookings-catalog-filters__calendar-modal-button md:hidden"
                            data-feature="open-modal" data-target="calendar-modal">
                            <span class="icon-calendar icon-orange"></span>
                        </a>
                    </div>

                    <div v-if="startDate.date || endDate.date" class="my-bookings-catalog-filters__tags">
                        <div v-if="startDate.date" class="orange-tag">
                            <span class="value">{{ startDate.date }}</span>
                            <span @click="resetDates('startDate')" class="icon-close close"></span>
                        </div>
                        <div v-if="endDate.date" class="orange-tag">
                            <span class="value">{{ endDate.date }}</span>
                            <span @click="resetDates('endDate')" class="icon-close close"></span>
                        </div>
                    </div>

                    <div class="my-bookings-catalog-filters__calendar-buttons">
                        <functional-calendar :configs='calendarConfigs' v-model='startDate'
                            class='single-calendar min-w-[250px] md:w-full' @choseDay='changeStartDate'>
                            <template v-slot:datePickerInput='props'>
                                <theme-input :value="startDateComputed" name='start_date' :isExtraInfo='true'
                                    :isReadonly='true' :placeholder="chooseStartDatePlaceholder">
                                    <template slot='extra-info'>
                                        <i class='icon-calendar' />
                                    </template>
                                </theme-input>
                            </template>
                        </functional-calendar>

                        <functional-calendar :configs='calendarConfigs' v-model='endDate'
                            class='single-calendar min-w-[250px] md:w-full' @choseDay='changeEndDate'>
                            <template v-slot:datePickerInput='props'>
                                <theme-input :value="endDateComputed" name='end_date' :isExtraInfo='true'
                                    :isReadonly='true' :placeholder="chooseEndDatePlaceholder">
                                    <template slot='extra-info'>
                                        <i class='icon-calendar' />
                                    </template>
                                </theme-input>
                            </template>
                        </functional-calendar>

                        <button v-if="startDate.date || endDate.date" @click="resetDates" class="theme-btn theme-btn--small theme-btn--tertiary whitespace-nowrap">
                            <span class="icon-replay my-bookings-catalog__modal-icon"></span>
                            {{ resetDatesText }}
                        </button>
                    </div>

                </div>

                <ul class="my-bookings-catalog-filters__status-filter">
                    <li>
                        <button @click="changeStatus('')" class="my-bookings-catalog-filters__status-filter-btn"
                            :class="{ 'active': activeStatus === '' }">
                            {{ locales && locales.common && locales.common.all }}
                        </button>
                    </li>
                    <li>
                        <button @click="changeStatus('Upcoming')" class="my-bookings-catalog-filters__status-filter-btn"
                            :class="{ 'active': activeStatus === 'Upcoming' }">
                            {{ locales && locales.common && locales.common.upcoming }}
                        </button>
                    </li>
                    <li>
                        <button @click="changeStatus('Past')"
                            class="my-bookings-catalog-filters__status-filter-btn"
                            :class="{ 'active': activeStatus === 'Past' }">
                            {{ locales && locales.common && locales.common.past }}
                        </button>
                    </li>
                    <li>
                        <button @click="changeStatus('Cancelled')"
                            class="my-bookings-catalog-filters__status-filter-btn"
                            :class="{ 'active': activeStatus === 'Cancelled' }">
                            {{ locales && locales.common && locales.common.cancelled }}
                        </button>
                    </li>
                    <li>
                        <button @click="changeStatus('Rejected')"
                            class="my-bookings-catalog-filters__status-filter-btn"
                            :class="{ 'active': activeStatus === 'Rejected' }">
                            {{ locales && locales.common && locales.common.rejected }}
                        </button>
                    </li>
                    <li>
                        <button @click="changeStatus('Requested')"
                            class="my-bookings-catalog-filters__status-filter-btn"
                            :class="{ 'active': activeStatus === 'Requested' }">
                            {{ locales && locales.common && locales.common.requested }}
                        </button>
                    </li>
                </ul>
            </div>

            <div class="my-bookings-catalog-list">
                <span class="text-[14px] font-semibold">{{ bookings.total }} {{ locales && locales['property-bookings'] && locales['property-bookings'].bookings }}</span>

                <div class="my-bookings-catalog-list__upper">
                    <div class='theme-order-select'>
                        <select class='theme-order-select__item' name='order'
                            @change="(e) => sort(e, 'orderDirection')">
                            <option v-for="(item, key) in orderDirections" :value="key" :key="key"
                                :selected="orderDirection === key">{{ item }}</option>
                        </select>
                    </div>

                    <div class='theme-order-select'>
                        <select class='theme-order-select__item' name='order' @change="(e) => sort(e, 'orderBy')">
                            <option v-for="(item, key) in ordering" :value="key" :key="key" :selected="orderBy == key">
                                {{ item }}
                            </option>
                        </select>
                    </div>
                </div>
                <ul class="my-bookings-catalog-list__list" v-if="bookings.total > 0">
                    <li v-for="(booking, i) in bookings.data" :key="booking.id">
                        <MyBookingItem :booking="booking" :token="token" :bookingApprovedText="bookingApprovedText"
                            :bookingPaidText="bookingPaidText" :makePaymentText="makePaymentText"
                            :successText="successText" :rejectBookingText="rejectBookingText"
                            :lang="lang"
                            :viewDetailsText="viewDetailsText" />
                    </li>
                </ul>
            </div>
        </div>
        <!-- Modals -->
        <div class="modal modal--calendar" data-feature="modal" data-name="calendar-modal">
            <div class="modal__content" data-feature="modal-active-area">
                <button class="modal__close" data-feature="close-modal" data-target="calendar-modal">
                    <i class="icon-close"></i>
                </button>
                <h3 class="mb-5">{{ chooseDatePlaceholder }}</h3>
                <div class="mb-4">
                    <div class="flex gap-4 mb-4">
                        <theme-input :value="startDateComputed" name='start_date' :isExtraInfo='true' :isReadonly='true'
                            :placeholder="chooseStartDatePlaceholder"
                            :class="{ 'focused': focusedModalInput === 'startDate' }"
                            @focus="() => changeFocusedInput('startDate')">
                            <template slot='extra-info'>
                                <i class='icon-calendar' />
                            </template>
                        </theme-input>

                        <theme-input :value="endDateComputed" name='end_date' :isExtraInfo='true' :isReadonly='true'
                            :placeholder="chooseEndDatePlaceholder"
                            :class="{ 'focused': focusedModalInput === 'endDate' }"
                            @focus="() => changeFocusedInput('endDate')">
                            <template slot='extra-info'>
                                <i class='icon-calendar' />
                            </template>
                        </theme-input>
                    </div>

                    <!-- v-model='startDate' -->
                    <functional-calendar :configs='modalCalendarConfigs' class='single-calendar' @choseDay='changeDate'>
                    </functional-calendar>

                    <div class="flex gap-4 justify-between">
                        <button @click="resetDates" class="theme-btn theme-btn--small theme-btn--tertiary pl-0"
                            :class="{ 'theme-btn--tertiary-disabled': startDate.date === '' && endDate.date === '' }">
                            <span class="icon-replay my-bookings-catalog__modal-icon"></span>
                            {{ resetDatesText }}
                        </button>

                        <button data-feature="close-modal" data-target="calendar-modal"
                            class="theme-btn theme-btn--theme"
                            :class="{ 'theme-btn--theme-disabled': startDate.date === '' && endDate.date === '' }">
                            {{ saveChangesText }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { FunctionalCalendar } from 'vue-functional-calendar';
import MyBookingItem from './MyBookingItem.vue';
import debounce from 'lodash/debounce';


export default {
    components: { FunctionalCalendar, MyBookingItem },
    props: {
        // bookings: {
        //     default: {},
        //     Type: Object,
        // },
        ordering: {
            default: {},
            Type: Object,
        },
        page: {
            type: Object,
            default: () => ({})
        },
        orderDirections: {
            default: {},
            Type: Object,
        },
        searchtermPlaceholder: {
            default: '',
            Type: String,
        },
        chooseDatePlaceholder: {
            default: '',
            Type: String,
        },
        chooseStartDatePlaceholder: {
            default: '',
            Type: String,
        },
        chooseEndDatePlaceholder: {
            default: '',
            Type: String,
        },
        resetDatesText: {
            default: '',
            Type: String,
        },
        saveChangesText: {
            default: '',
            Type: String,
        },
        rejectBookingText: {
            default: '',
            Type: String,
        },
        token: {
            default: '',
            Type: String,
        },
        bookingApprovedText: {
            default: '',
            Type: String,
        },
        bookingPaidText: {
            default: '',
            Type: String,
        },
        makePaymentText: {
            default: '',
            Type: String,
        },
        successText: {
            default: '',
            Type: String,
        },
        viewDetailsText: {
            default: '',
            Type: String,
        },
        lang: {
            default: 'nl',
            Type: String,
        },
        monthNames: {
            default: () => { return [] },
            type: Array
        },
        dayNames: {
            default: () => { return [] },
            type: Array
        },
    },
    data() {
        return {
            searchTerm: new URL(window.location).searchParams.get('searchTerm') || '',
            startDate: { date: new URL(window.location).searchParams.get('startDate') || '' },
            endDate: { date: new URL(window.location).searchParams.get('endDate') || '' },
            orderBy: new URL(window.location).searchParams.get('orderBy') || '',
            orderDirection: new URL(window.location).searchParams.get('orderDirection') || '',
            activeStatus: new URL(window.location).searchParams.get('activeStatus') || '',
            bookings: [],
            calendarConfigs: {
                dateFormat: 'dd-mm-yyyy',
                isModal: true,
                isDatePicker: true,
                isAutoCloseable: true,
                monthNames: this.monthNames,
                dayNames: this.dayNames
            },
            modalCalendarConfigs: {
                dateFormat: 'dd-mm-yyyy',
                isDatePicker: true,
                monthNames: this.monthNames,
                dayNames: this.dayNames
            },
            focusedModalInput: 'startDate',
        };
    },
    computed: {
        ...mapGetters(['locales']),
        startDateComputed() {
            return this.startDate.date ? this.startDate.date : '';
        },
        endDateComputed() {
            return this.endDate.date ? this.endDate.date : '';
        },
        filters() {
            return [this.searchTerm, this.startDate, this.endDate, this.orderBy, this.orderDirection, this.activeStatus]
        }
    },

    methods: {
        fetchData: async function () {
            const query = new URLSearchParams({
                searchTerm: this.searchTerm,
                startDate: this.startDate.date,
                endDate: this.endDate.date,
                activeStatus: this.activeStatus,
                orderBy: this.orderBy,
                orderDirection: this.orderDirection,
            }).toString();

            try {
                const response = await fetch(`/api/property-bookings/?${query}&front=true`);
                const data = await response.json();
                this.bookings = data;
            } catch (error) {
                console.error('Error fetching data:', error);
                this.dummyBookings = [];
            }
        },
        changeSearchTerm: function (searchTerm) {
            this.searchTerm = searchTerm;
            this.setSearchParam('searchTerm', searchTerm);
        },
        showState: function () {
            // console.log(this.orderDirection);
        },
        changeStartDate: function (value) {
            this.startDate = { date: value.date };
            this.setSearchParam('startDate', value.date)
        },
        changeEndDate: function (value) {
            this.endDate = { date: value.date };
            this.setSearchParam('endDate', value.date)
        },
        changeFocusedInput: function (inputName) {
            inputName === 'startDate'
                ? this.focusedModalInput = 'startDate'
                : this.focusedModalInput = 'endDate';
        },
        changeDate: function (value) {
            if (this.focusedModalInput === 'startDate') {
                this.startDate = { date: value.date };
            } else {
                this.endDate = { date: value.date }
            }
            this.setSearchParam(this.focusedModalInput, value.date)
        },
        resetDates: function (dateType) {
            if (dateType === 'startDate') {
                this.startDate = { date: '' };
                this.removeSearchParam(dateType);
            } else if (dateType === 'endDate') {
                this.endDate = { date: '' };
                this.removeSearchParam(dateType);
            } else {
                this.startDate = { date: '' };
                this.endDate = { date: '' };
                this.removeSearchParam('startDate');
                this.removeSearchParam('endDate');
            }
        },
        sort: function (e, selectType) {
            if (selectType === 'orderBy') {
                this.orderBy = e.target.value;
                this.setSearchParam('orderBy', e.target.value);
            } else if (selectType === 'orderDirection') {
                this.orderDirection = e.target.value;
                this.setSearchParam('orderDirection', e.target.value);
            };
        },
        changeStatus: function (statusName) {
            if (statusName) {
                this.activeStatus = statusName;
            } else {
                this.activeStatus = '';
            }
            this.setSearchParam("activeStatus", statusName);
        },
        setSearchParam: function (param, value) {
            const url = new URL(window.location);
            url.searchParams.set(param, value);
            window.history.pushState({}, "", url);
        },
        removeSearchParam: function (param) {
            const url = new URL(window.location);
            url.searchParams.delete(param);
            window.history.pushState({}, "", url);
        }        
    },
    mounted() {
        // uncomment this when endpoint will be added
        this.fetchData();
    },
    created() {
        this.debouncedChangeSearchTerm = debounce(this.changeSearchTerm, 500);
    },
    watch: {
        filters() {
            this.fetchData();
        }
    }
};
</script>